import React, {useEffect} from "react";
import useShop from "./useShop";
import Card from "../../Components/Cards/Card";
import SubmitButton from "../../Components/Buttons/SubmitButton";
import axios from "axios";
import swal from "sweetalert";
import {useNavigate} from "react-router-dom";

export default function () {
  const {shopFields, handleSubmit, setData, setErrors} = useShop();
  const navigate = useNavigate();

  useEffect(() => {
    axios.get('shops/create')
      .then(res => {
        setData(res.data.data);
      });
  }, []);

  const addShop = data => {
    const formData = new FormData();

    Object.entries(data).forEach(([property, value]) => {
      formData.append(`${property}`, value === 0 ? value : (value || ''));
    });

    axios.post('shops', formData, {
      headers: {
        'Password-reset': true,
      },
    }).then(function (res) {
      if (res.status == 200) {
        swal('Shop "' + data.name + '" has been created successfully!', {
          icon: "success",
        });
        navigate("/shops");
      }
    }).catch(function (error) {
      if (error.response) {
        setErrors(error.response.data.errors || {});
      }
    });
  }

  return (
    <Card title="Add seller">
      <form className="form w-100" onSubmit={handleSubmit(addShop)}>
        {shopFields}

        <SubmitButton title="Add"/>
      </form>
    </Card>
  );
}